import { withDateAdapter, withDateAdapterPage } from '../../shared/rxjs/with-date-adapter';

import { DateAdapter } from '../../shared/adapters/date-adapter';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from '../../shared/models/pagination.model';
import { VaccineHistory } from './../../shared/models/vaccine-history.model';
import { environment as env } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VaccineHistoryService {
  private readonly endpoint = `${env.baseAPIUrl}/vaccine-history`;

  private readonly dateFields = ['date', 'createdAt', 'updatedAt', 'deletedAt', 'nextDose'];
  private readonly transformDate = withDateAdapter<VaccineHistory>(this.dateFields);
  private readonly transformDatePage = withDateAdapterPage<Pagination<VaccineHistory>>(this.dateFields);

  constructor(private readonly http: HttpClient) { }

  getVaccineHistoryById(vaccineHistoryId: string): Observable<VaccineHistory> {
    return this.http.get<VaccineHistory>(`${this.endpoint}/${vaccineHistoryId}`)
      .pipe(this.transformDate);
  }

  paginateVaccineHistoryByPetId(petId: string, page: number = 0, pageSize: number = 10): Observable<Pagination<VaccineHistory>> {
    return this.http.get<Pagination<VaccineHistory>>(`${this.endpoint}/pet/${petId}?page=${page}&pageSize=${pageSize}`)
      .pipe(this.transformDatePage);
  }

  createVaccineHistory(vaccineHistory: VaccineHistory): Observable<VaccineHistory> {
    return this.http.post<VaccineHistory>(`${this.endpoint}`, DateAdapter.toAPI(vaccineHistory, this.dateFields))
      .pipe(this.transformDate);
  }

  updateVaccineHistory(vaccineHistory: VaccineHistory): Observable<VaccineHistory> {
    return this.http.patch<VaccineHistory>(`${this.endpoint}/${vaccineHistory.id}`, DateAdapter.toAPI(vaccineHistory, this.dateFields))
      .pipe(this.transformDate);
  }

  deleteVaccineHistory(vaccineHistoryId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${vaccineHistoryId}`)
  }
}
